import { ADD_INGREDIENTS_TO_GROCERY_WAITLIST } from "./actionTypes";

export default (payload) => ({
  type: ADD_INGREDIENTS_TO_GROCERY_WAITLIST,
  payload,
});
